const COUNTRY_REGEX = /^[a-z]{2}$/i;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const PUBKEY_REGEX = /^flwpubk(?:_test)?-[\da-f]{32}-x$/i;
const CHECKSUM_REGEX = /^[\da-f]{32}(?:[\da-f]{8}(?:[\da-f]{24})?)?$/i;
const USSD_CODE_REGEX = /((?:\*\d+)(?:\*\d+(?:\+\d+)*)+#)(?:\|(\d+))?/;
const UUID_REGEX = /^[\da-f]{8}-[\da-f]{4}-[1-5][\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
const IPV4_REGEX = /^(?:(?:[1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:[1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])$/;

export {
  CHECKSUM_REGEX,
  COUNTRY_REGEX,
  EMAIL_REGEX,
  IPV4_REGEX,
  PUBKEY_REGEX,
  USSD_CODE_REGEX,
  UUID_REGEX
}
